export default __webpack_public_path__ + "static/media/Sarah-Ryan.8dae1f82.png";